export default function validatePassengers (passengers, maxPassengers = 5) {
  const totalPassegers = Object.values(passengers).reduce((total, value) => (total + value), 0);
  return totalPassegers > maxPassengers;
}
